const audioPath = {
  1: '/audio/POP1.mp3',
  2: '/audio/POP2.mp3',
  3: '/audio/HipHop1.mp3',
  4: '/audio/HipHop2.mp3',
  5: '/audio/Rock1.mp3',
  6: '/audio/Rock2.mp3',
  7: '/audio/RB1.mp3',
  8: '/audio/RB2.mp3',
  9: '/audio/Jazz1.mp3',
  10: '/audio/Jazz2.mp3',
};

export default audioPath;
